var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg3833",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 88.6",
    width: 120,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0,.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:.425}.st1{stroke-width:.5858}.st2{fill:#FFFFFF}.st3{fill:#FFFFFF}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-258.18 -466.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path448",
    className: "st0",
    d: "M281.2 488.3s2.7-.7 4.8-.3c2.1.4.4 1.7.4 1.7s-2.1 1.2-4.2 1.5c-2.1.4-1-2.4-1-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path456",
    className: "st1",
    d: "M273.7 479.3s-1.7 4.8.9 6.7c2.5 1.8 4.7-.6 5.1-.6.3-.1-.8-.7-.8-.7s-.5.6-1.7.9c-3.1.9-4.1-3.2-3.1-6 0-.1-.2-.5-.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path440",
    className: "st1",
    d: "M277.7 477.4s-3.2 4.8-.9 7.2c2.2 2.3 5.2 0 5.6 0 .3 0-.7-.8-.7-.8s-.7.6-2.1.7c-3.6.5-3.5-3.9-1.7-6.7.2 0 .1-.5-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path392",
    className: "st1",
    d: "M280.4 487.8s-.9-6 2.4-9.8c3.3-3.8 5.3-5 6-7.1.7-2 .9-3.9.7-4.1-.2-.2-.4.8-.4 1 0 .7-.5 2.6-1.4 3.7-2.2 3.1-4.8 4.6-6.1 6.6-.9 1.5-2.7 4.4-2.2 8.4s1 1.3 1 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path408",
    className: "st1",
    d: "M286 473.8c-1.7-1.7-1.3-4.5 0-5.6.1 0 0-.5-.2-.5 0 0-2.8 2.3-1 5.5.2.4.5.8.8 1.1l.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path416",
    className: "st1",
    d: "M281.6 479.4c-1.3-1.7-.9-4.2.4-5.2 0 0 0-.5-.2-.5 0 0-2.8 2.3-1 5.5.1.2.3.5.4.7l.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path400",
    className: "st1",
    d: "M295.4 475.3s1.2 6-2.2 7.4c-3.2 1.3-5.3-2.1-5.7-2.3-.3-.2 1.1-.6 1.1-.6s.5.8 1.8 1.6c3.4 2 5.3-2.4 4.6-5.9 0 0 .3-.5.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path384",
    className: "st1",
    d: "M281 488s2-6.1 7.8-7.7c5.8-1.6 8.6-1.5 10.6-3.2 2-1.7 4.1-5.2 3.7-5.2-.4-.1-1.2.9-1.4 1.2-.5.7-2.3 2.9-3.8 3.6-2.8 1.3-8.7 1.8-10.6 2.7-1.9 1-5.5 2.8-7.4 7.8-1.9 5 1.1.8 1.1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path424",
    className: "st1",
    d: "M298.8 476.9c-1.1-2.8.2-5.9 2.5-7.1.1-.1.7-.7.4-.8 0 0-5.1 2.2-4 7.3.1.4.2.7.3 1.1l.8-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path432",
    className: "st1",
    d: "M287.2 477.7s3 5 .3 7.9c-2.5 2.7-5.6.5-6 .5-.3 0 .8-1 .8-1s.7.5 2.1.6c3.8.2 4.2-4.7 2.4-7.5 0 0 .1-.6.4-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path460",
    className: "st2",
    d: "M361.8 479.5c-.8 1-.8 2.5-.8 3.8v10.8c0 1.3 0 2.8.8 3.8l-4.2.2.1-1.9c0-.1-.1-.1-.2-.1s-.2.2-.4.3c-1.4 1-3.6 2-6.9 2-4.1 0-6.9-1.4-7-4.9v-10.2c0-1.3 0-2.8-.8-3.8h4.8c-.8 1-.8 2.5-.8 3.8v8.4c.1 3.1 1.7 5 5.7 5 4.1 0 5.4-2.1 5.5-5.5 0-1.1.1-2.2.1-3.3v-4.5c0-1.3 0-2.8-.8-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path464",
    className: "st2",
    d: "M365.1 497.9c1.2-2.4 1.2-5.9 1.2-8.4v-6.1c0-1.4-.1-3-1.1-3.8h3.6c.7 0 1 0 1.4.5.7.8 3 3.9 4.1 5.2l7.1 8.1c.2.3.5.7.7.7.3 0 .3-.3.3-.5v-10.2c0-2-.4-2.9-.9-3.7h3.7c-.9 1.3-1.1 2.8-1.1 4.3v11.5c0 1 0 1.8.1 2.7h-2.5l-13-15c-.1-.2-.3-.3-.4-.3-.1 0-.2.2-.2.4v7.4c0 2.3-.1 5.2 1.1 7.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path468",
    className: "st2",
    d: "M389.2 483.3c0-1.3 0-2.8-.8-3.8h4.8c-.8 1-.8 2.5-.8 3.8v10.8c0 1.3 0 2.8.8 3.8h-4.8c.8-1 .8-2.5.8-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path472",
    className: "st2",
    d: "M402 498l-.5-1.5c-1.7-4.6-4.2-11.7-6.7-16.1l-.6-1h3.2c.7 0 .9.7 1.1 1.1 1.9 4.5 3.9 8.9 5.4 13.5.2.5.4.8.6.8.2 0 .4-.5.6-.9 1-2.5 5.4-10.8 5.4-13.5 0-.4-.1-.7-.2-1h4.4l-.6.9c-3.4 4.9-6.1 10.7-8.5 16l-.7 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path476",
    className: "st2",
    d: "M420 496.8h4.1c2.2 0 4.5-.4 6.2-1.6l-.6 2.7c-1 .1-2.1.1-3.4.1H416c.8-1 .9-2.5.9-3.8v-10.8c0-1.3 0-2.8-.8-3.8h12.4l.1 2.2c-1.2-.9-3.2-1.1-5.3-1.1H420v6.9c2.7 0 5.6 0 8.4-.2-1.2 1.6-5.3 1.6-7.5 1.6h-.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path480",
    className: "st2",
    d: "M436.5 487.8c.5.1 1.1.1 1.6.1 3.5 0 5.3-1.5 5.3-4.2 0-2.9-2-3.2-5.2-3.3h-1.7c0 .4-.1.9-.1 1.4v6zm11 7.4c1 1.1 1.5 1.6 3 2.7h-2.9c-1.5 0-2.2-.7-3-1.6l-4.3-5c-1.5-1.7-1.7-2.2-3.8-2.4v5.2c0 1.3 0 2.8.8 3.8h-4.9c1-1.3 1-2.7 1-4v-10.7c0-1.3 0-2.8-.8-3.8 3 0 5.8-.3 8.6-.3 3.6 0 5.5 1.6 5.5 3.9 0 2.7-2.7 4.4-5.3 5.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path484",
    className: "st2",
    d: "M450.6 494.3c1.1 1.2 2.6 2.9 6.3 2.9 2.7 0 4.7-1.3 4.7-3.6 0-4.8-10.2-4.2-10.2-9.6 0-3.3 3.4-5 7.2-5 1.9 0 3.7.2 5.5.2v2.7c-1.6-1.4-2.6-1.7-4.9-1.7-2.5 0-4.3 1-4.3 3.2 0 4.4 10.2 3.9 10.2 9.4 0 3.6-4.3 5.6-8.3 5.6-1.7 0-4.5-.5-6.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path488",
    className: "st2",
    d: "M468.7 483.3c0-1.3 0-2.8-.8-3.8h4.8c-.8 1-.8 2.5-.8 3.8v10.8c0 1.3 0 2.8.8 3.8h-4.8c.8-1 .8-2.5.8-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path492",
    className: "st2",
    d: "M481.1 497.9c.8-1 .8-2.5.8-3.8V481h-4.7c-.8 0-1.6.1-2.5.6l.7-2.1h17.9c-.6 1.2-2.8 1.4-4.2 1.4h-3.9v13.2c0 1.3 0 2.8.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path496",
    className: "st2",
    d: "M499.3 497.9c.8-1 .8-2.5.8-3.8v-2.6c0-2-1.1-4-2.5-6.3-1.4-2.4-3.2-4.6-4.7-5.7h3.1c1.3 0 1.5.3 2.2 1.1 1.4 1.8 3 5.1 3.7 7.1.1.4.3.9.6.9.2 0 .5-.5.8-1l2.4-3.5c.8-1.2 1.6-2.6 1.6-3.4 0-.4-.1-.8-.5-1.2h4.5l-4.1 5.1c-2.5 3.1-3.8 4.5-3.8 8.3v1.2c0 1.3 0 2.8.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path500",
    className: "st2",
    d: "M531.5 480.3c-5.1 0-7.3 3.8-7.3 8 0 3.8 1.6 8.8 7.3 8.8 5.1 0 7.3-3.8 7.3-8 0-3.8-1.6-8.8-7.3-8.8zm-.3 18.1c-7.5 0-10.7-4.2-10.7-9.3 0-5.5 3.9-10 11.3-10 7.5 0 10.8 4.2 10.8 9.3-.1 5.4-4 10-11.4 10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path504",
    className: "st2",
    d: "M549.4 494.1c0 1.3 0 2.8.8 3.8h-4.8c.8-1 .8-2.5.8-3.8v-10.8c0-1.3.1-2.8-.7-3.8h11c.9 0 1.6 0 1.6.3v2.3h-.1c-1-1.3-3.2-1.4-4.9-1.4h-3.7v7.4c2.7 0 5.6 0 8.4-.2-1.2 1.6-5.3 1.6-7.5 1.6h-.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path508",
    className: "st2",
    d: "M341.7 536.7c2.1 2.7 5.2 6.5 12.7 6.5 5.4 0 9.5-2.9 9.5-8.1 0-10.8-20.4-9.5-20.4-21.4 0-7.5 6.8-11.2 14.3-11.2 3.7 0 7.3.4 11 .4v6c-3.2-3-5.1-3.8-9.9-3.8-5 0-8.7 2.3-8.7 7.1 0 9.9 20.4 8.7 20.4 21.1 0 8-8.6 12.5-16.6 12.5-3.5 0-9-1-12.2-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path512",
    className: "st2",
    d: "M412.6 503.6c-1.6 2.3-1.6 5.6-1.6 8.5v24.3c0 2.9 0 6.3 1.6 8.4l-8.5.4.3-4.3c0-.2-.1-.3-.4-.3-.1 0-.4.4-.9.7-2.8 2.1-6.5 4.5-13.2 4.5-8.3 0-13.7-3-14-11v-22.7c0-2.9 0-6.3-1.6-8.5h9.5c-1.6 2.3-1.6 5.6-1.6 8.5V531c.2 6.9 3.3 11.1 11.4 11.1 8.3 0 10.3-4.7 10.5-12.4.1-2.5.3-5 .3-7.4v-10.1c0-2.9 0-6.3-1.6-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path516",
    className: "st2",
    d: "M425.8 522.2c1.1.1 2.1.2 3.2.2 6.9 0 10.7-3.4 10.7-9.5 0-6.5-4.1-7.2-10.4-7.4H426c-.1 1-.1 2.1-.1 3.1v13.6zm22.2 16.6c2.1 2.5 3.1 3.6 6 6h-5.8c-3.1 0-4.4-1.5-6-3.6l-8.7-11.2c-3-3.9-3.5-5-7.6-5.3v11.6c0 2.9 0 6.3 1.6 8.5h-9.9c2.1-3 1.9-6.1 1.9-8.8v-24c0-2.9 0-6.3-1.6-8.5 6 0 11.7-.6 17.2-.6 7.3 0 11 3.6 11 8.7 0 5.9-5.4 9.8-10.5 11.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path520",
    className: "st2",
    d: "M462.1 522.2c1.1.1 2.1.2 3.2.2 6.9 0 10.7-3.4 10.7-9.5 0-6.5-4.1-7.2-10.4-7.4h-3.3c-.1 1-.1 2.1-.1 3.1v13.6zm22.7 16.6c2.1 2.5 3.1 3.6 6 6H485c-3.1 0-4.4-1.5-6-3.6l-8.7-11.2c-3-3.9-3.5-5-7.6-5.3v11.6c0 2.9 0 6.3 1.6 8.5h-9.9c2.1-3 1.9-6.1 1.9-8.8v-24c0-2.9 0-6.3-1.6-8.5 6 0 11.7-.6 17.2-.6 7.3 0 11 3.6 11 8.7 0 5.9-5.4 9.8-10.5 11.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path524",
    className: "st2",
    d: "M499.6 542.2h8.2c4.4 0 9-1 12.3-3.7l-1.3 5.9c-1.9.1-4.3.3-6.8.3h-20.6c1.6-2.2 1.8-5.6 1.8-8.5V512c0-2.9 0-6.3-1.6-8.5h24.9l.3 5c-2.5-1.9-6.3-2.4-10.5-2.4h-6.6v15.4c5.5 0 11.2 0 16.7-.5-2.5 3.7-10.5 3.7-15 3.7h-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path528",
    className: "st2",
    d: "M530.9 544.8c1.6-2.2 1.6-5.6 1.6-8.5v-5.9c0-4.5-2.1-8.8-5-14.1-2.9-5.3-6.5-10.3-9.4-12.7h6.1c2.6 0 3.2.5 4.3 2.5 2.7 4.9 5.4 11.2 7.4 16 .4.9.6 1.9 1.1 1.9.4 0 .9-1.1 1.6-2.3l4.8-7.8c1.6-2.6 3.2-5.8 3.2-7.7 0-1-.3-1.8-1.1-2.6h9l-8.1 11.4c-5 6.9-7.7 10.1-7.7 18.6v2.7c0 2.9 0 6.3 1.6 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path532",
    className: "st3",
    d: "M286.5 549c11.6-2.2 25.6-.5 33.2.6 4.2.6 5.6.3 5.6.3s-4.4-.9-6.8-1.6c-12.2-3.5-44.8-9.1-46.6 6.8-.1 0 4-4.2 14.6-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path536",
    className: "st3",
    d: "M277.9 538.9c1.2 0 2.3 1.1 2.3 2.4 0 1.3-1 2.4-2.3 2.4-1.3 0-2.3-1.1-2.3-2.4 0-1.4 1-2.4 2.3-2.4zm44.2-15.7c-.2-1.4.4-8.1.4-8.1l.6 7s1.3-2.1 1.5-6.4c.2-5.2-2.3-8.7-6.3-10-2-.7-3.8-.3-5-.1-4 .4-7.5.1-9 .1-8.9.4-11.1-2.4-12.8-5-3.3-5-3.9-4.3-7.1-10.8-2.7-5.4-5.2-2-9.6-.6-1.3.4-5.7 2.1-6.1 2.2-.4.2-.3 1.1-.2 1.5 0 .2 1.1 1.3 1.4 1.5.3.1 6.7 1.8 8.5 2.2 0 0 .7 1.5-.9 6.9-1.2 4.1.2 6.5.2 6.5s-2.4-1.7-4.6-3.2c-2.2-1.5-9.2 1.6-13.3 4.5-1.7 1.2-1.4 2.9-1.4 2.9l2 4.5 1.9-1.1c-.7-.2-1.2-.9-1.2-1.6 0-.9.8-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7v.1c.3-.6.9-1 1.5-1 .9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7h-.1c.5.3.8.8.8 1.4 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-.2 0-.3.1-.5l-2 .9 2 3.9 5.6-2.7 6 14.3-2.6 8.3 8.6 3.2 3.1-8.5-6.4-3.7-10.5-24.9.2-.1c1.1-.4 2.1-.7 3.1-1 2-.6 8 8.3 9.2 9.1 1.7 1.1 2.7.9 3.8 1h-.1c-.1-.1-.3-.2-.4-.3-5.4-4.2-3.2-12-3.2-12 .1 8 4.8 13.1 4.9 13.5v.1c.1.2.2.3.3.6 1.5 3-.8 24.7-.8 24.7l2.3-1s4.2-21.6 4.8-21.5c10.1 1.8 14.8-6.1 18.7 8.7.6 2.1-11.7 12.7-11.7 12.7s2.4.4 4.1-.9c4.6-3.4 13-12.1 12.6-12.4-.6-.4-2.3-3.8-2.3-4.4 0-.5.4-2.3.9-2.9-.1-.1-.3-.1-.4-.2-5.6-2.8-5.6-11.9-5.6-11.9 2 8.3 7 12.3 7.4 12.8 1.8 2 5.6 6.7 5.9 8.7.4 2.4-9 13.5-9 13.5s3.7.5 4.3-1c.5-1.1 9.9-12.9 9.7-13.9-.5-1-3.6-7.6-3.8-9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurrey);
export default __webpack_public_path__ + "static/media/surrey.b9f6d82babdcd20d122a6ec53f2eb96a.svg";
export { ForwardRef as ReactComponent };